module.exports = __webpack_public_path__ + "static/media/1-ico.3c80284.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/1-ico.mp3
// module id = 8H+x
// module chunks = 0